import { action, computed, makeObservable } from 'mobx';

import { requireService } from 'src/packages/di';

export class AlertsGeneralSettingsStore {
  constructor(private readonly alertsGeneralPreference = requireService('alertsGeneralPreference')) {
    makeObservable(this);
  }

  @computed
  get saveToJournal() {
    return this.alertsGeneralPreference.preferences.settings.saveToJournal ?? false;
  }

  @action.bound
  setSaveToJournal(value: boolean) {
    this.alertsGeneralPreference.updatePreferences({ saveToJournal: value });
  }

  get isLoading() {
    return this.alertsGeneralPreference.isLoading;
  }
}
